import React, { useState } from "react";
import Input from "./InputYeni";
import Button from "./Button";
import MaviAlert from "../projeler/MaviAlert";
import { useDispatch, useSelector } from "react-redux";
import { sifremiUnuttumRequest } from "../../redux/actions/sifremiUnuttumAction";
import { setShowAlert } from "../../redux/slices/sifremiUnuttumSlice";

const SifremiUnuttum = () => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const { loading, error, alertMessage, showAlert } = useSelector(
    (state) => state.sifremiUnuttum
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(sifremiUnuttumRequest(email));
  };

  const handleAlertConfirm = () => {
    dispatch(setShowAlert(false));
  };

  const handleAlertClose = () => {
    dispatch(setShowAlert(false));
  };

  return (
    <div className="containerMain grid grid-cols-1 mx-auto place-items-center h-auto">
      <form
        className="form-container flex flex-col gap-8"
        onSubmit={handleSubmit}
      >
        <div className="w-[80%] grid place-items-center my-3 ">
          <img src="/logo.svg" alt="logo" className="w-full border-b-2 pb-5" />
        </div>
        <div className="flex flex-col gap-4">
          <p className="text-xl font-medium text-dark text-center">
            Şifremi unuttum
          </p>
          <p className="text-base font-normal text-grayy text-center max-w-[376px]">
            Şifrenizi unuttuysanız, hesabınıza erişebilmeniz için lütfen geçerli
            e-posta adresinizi girin. E-posta adresinize şifre sıfırlama
            bağlantısı gönderilecektir
          </p>
        </div>
        <Input
          page="sifre-yenileme"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button page="sifre-yenileme" loading={loading} />
        {error && <p className="text-red-500 mt-2">{error}</p>}
      </form>
      {showAlert && (
        <MaviAlert
          message={alertMessage}
          onConfirm={handleAlertConfirm}
          onClose={handleAlertClose}
          hideButtons={true}
        />
      )}
    </div>
  );
};

export default SifremiUnuttum;
